import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'
import "flatpickr/dist/flatpickr.min.css"
import 'time-input-polyfill';

import VueCookies from 'vue-cookies'
import moment from 'moment'
import Echo from 'laravel-echo'
import io from 'socket.io-client'
import Swal from 'sweetalert2'
import flatpickr from "flatpickr"

require("dotenv").config()

/* socket.io-client */
window.io = io
// HTTPS 時走同網域 443 + /socket.io（Nginx 反代到 6001），HTTP 時直連 :6001
const wsHost = window.location.protocol === 'https:' ? window.location.host : window.location.hostname + ':6001'
window.Echo = new Echo({
  broadcaster: 'socket.io',
  host: wsHost,
  reconnect: true,
  transports: ['websocket', 'polling'],
})

const vm = createApp(App)
vm.use(router)

vm.config.globalProperties.$cookies = VueCookies
vm.config.globalProperties.$moment = moment
vm.config.globalProperties.$swal = Swal
vm.config.globalProperties.$flatpickr = flatpickr

/* 等初始路由（含懶加載頁）就緒再 mount，避免尚未解析成 Shop 就被 isLogin 導回首頁 */
router.isReady().then(() => {
  vm.mount('#app')
})
